const ChangeInConditionPageState = Object.freeze({
    SELECT_CHANGE_IN_CONDITION: 1,
    SYMPTOMS: 2,
    ASSESSMENT: 3
})

export default ChangeInConditionPageState